import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { FixedbottomButtonCover } from "../../../common";
import primaryComponents from "../../../primaryComponents";
import { AdditionalDetailsForm } from "./AdditionalDetailsForm";
import { BasicInfo } from "./BasicInfo";
import { PriceSummary } from "./PriceSummary";
import { ProductSelection } from "./ProductSelection";
import styles from "./styles.module.scss";
import { useGoodsReceivedForm } from "./useGoodsReceivedForm";
import { useValidation } from "./useValidation";

export const GoodsReceivedForm = ({ isEditMode = false, GRDetails = {} }) => {
  const {
    isSubmittingGR,
    gRForm,
    pODetails,
    isLoadingWaybillFile,
    setGRForm,
    createOrUpdateGR,
    handleUploadWaybill,
  } = useGoodsReceivedForm({ isEditMode, GRDetails });
  const { handleSubmit, ...validationParams } = useValidation({ ...gRForm });

  return (
    <form
      className={`${globalStyles.pageColumnGaps} ${styles.purchaseOrderForm}`}
      onSubmit={handleSubmit(() => createOrUpdateGR("IN_REVIEW"))}
    >
      <div className={styles.formTop}>
        <BasicInfo
          {...validationParams}
          isEditMode={isEditMode}
          gRForm={gRForm}
          pODetails={pODetails}
          setGRForm={setGRForm}
        />
        <ProductSelection
          {...validationParams}
          gRForm={gRForm}
          setGRForm={setGRForm}
        />
      </div>

      <PriceSummary {...validationParams} gRForm={gRForm} />

      <AdditionalDetailsForm
        {...validationParams}
        gRForm={gRForm}
        setGRForm={setGRForm}
        handleUploadWaybill={handleUploadWaybill}
      />

      <FixedbottomButtonCover>
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          style={{ width: "200px" }}
          type="button"
          isDisabled={isSubmittingGR || isLoadingWaybillFile}
          isLoading={isSubmittingGR}
          loadingText={"Saving as draft..."}
          onClick={handleSubmit(() => createOrUpdateGR("DRAFT"))}
        >
          Save As Draft
        </primaryComponents.Button>

        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto"}
          style={{ width: "200px" }}
          type="submit"
          isDisabled={isSubmittingGR || isLoadingWaybillFile}
          isLoading={isSubmittingGR}
          loadingText={isEditMode ? "Updating GRN..." : "Creating GRN..."}
        >
          {isEditMode ? "Update GRN" : "Create GRN"}
        </primaryComponents.Button>
      </FixedbottomButtonCover>
    </form>
  );
};
